<template>
  <div class="content">
    <div class="row">
      <div class="col-12">
        <card class="card-plain">
          <!-- <template slot="header">
            <h4 class="card-title">Table on Plain Background</h4>
            <p class="category">Here is a subtitle for this table</p>
          </template>-->
          <div class="table-full-width text-left">
            <name-table
            v-if="names && names.length > 0"
				:title="table1.title"
				:sub-title="table1.subTitle"
				:names="names"
				:totalElements="totalElements"
				:page="page"
				:columns="table1.columns"
 				@get-all-names="getAllNames"
             >

            </name-table>
          </div>
        </card>
      </div>

    </div>
  </div>
</template>
<script>
import { Card } from "@/components/Card";

import NameTable from "@/components/NameTable";
import NameService from "../services/NameService";

const tableColumns = [];
const tableData = [
];

export default {
  components: {
    Card,
    NameTable,
  },
  data() {
    return {
      names: [],
	  totalElements: 0,
      page: 0,
      searchQuery: '',     
      table1: {
        title: "Simple Table",
        columns: [...tableColumns],
        data: [...tableData],
      },
    };
  },
  methods: {
    async getAllNames(sortBy='nameId',sortOrder='true',page="0",size="50") {
      try {
        try {
			const searchDTO = {
				sortBy: sortBy, 
				sortOrder: sortOrder, 
				searchQuery: this.searchQuery,
				page: page, 
				size: size
			};
	        let response = await NameService.getAllNames(searchDTO);
	        if (!response.data.empty) {
		        if (response.data.names.length) {
					this.names = response.data.names;
				}
      			this.totalElements = response.data.totalElements;
      			this.page = response.data.page;
	        }
        } catch (error) {
          console.error("Error fetching names:", error);
        }
        
      } catch (error) {
        console.error("Error fetching name details:", error);
      }
    },
  },
  mounted() {
    this.getAllNames();
  },
  created() {
    this.$root.$on('searchQueryForNamesChanged', (searchQuery) => {
    	this.searchQuery = searchQuery;
    	this.getAllNames();
    })
  }
};
</script>
<style></style>
